<template>
  <div class="pdbItemInfo">
    <table :id="'pdbItemInfo_content_'+ pdbInfo.name" width="100%">
      <tr>
        <th>Names</th>
        <td>
          <span class="text-break">{{pdbInfo.names || 'Unknown'}}</span>
        </td>
      </tr>
      <tr>
        <th>UniprotID</th>
        <td>{{pdbInfo.uniprotId || 'Unknown'}}</td>
      </tr>
      <tr>
        <th>Description</th>
        <td>
          <span>{{pdbInfo.description || 'No description'}}</span>
        </td>
      </tr>
      <tr>
        <th>Organism</th>
        <td>
          <span>{{pdbInfo.organism || 'Unknown'}}</span>
        </td>
      </tr>
      <tr>
        <th>Ligands</th>
        <td>
          <span v-if="pdbInfo.ligands && pdbInfo.ligands.length > 0">
            <span v-for="(l, index) in pdbInfo.ligands" v-bind:key="index">
              {{l}}
              <br />
            </span>
          </span>
          <span v-else>None</span>
        </td>
      </tr>
      <tr>
        <th>Part of the heterocomplex</th>
        <td>{{pdbInfo.isComplex ? 'yes': 'no'}}</td>
      </tr>
        <tr>
        <th>Subcluster members</th>
        <td>
          <span v-if="pdbInfo.members && pdbInfo.members.length > 0">
            <span v-for="(l, index) in pdbInfo.members" v-bind:key="index">
              <a :href="'https://www.rcsb.org/structure/'+l.substring(0, 4)" target="_blank" title="View at RSCB">{{l}}</a>
              <br />
            </span>
          </span>
          <span v-else></span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "PDBItemInfo",
  props: {
    pdbInfo: {}
  }
};
</script>

<style scoped>
</style>
